export const normalizeNoteSpaces = (html = '') =>
  html.replace(/\u00a0/g, ' ').replace(/&nbsp;|&#160;|&#x0*a0;/gi, ' ');
